exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message-policy .badge {\n  margin: 5px;\n  font-size: 15px; }\n\n.message-policy .select {\n  z-index: 999 !important; }\n\n.Add-phone .btn-outline-secondary {\n  width: 70px; }\n\n.message-form .required {\n  color: red; }\n", ""]);

// exports
